/* eslint-disable react/prop-types */
import React from 'react';
//==========================Styles==========================//
import styles from './styles';
import { makeStyles } from '@mui/styles';
import classNames from 'classnames';

const useStyles = makeStyles(styles);

export default function PortletHeader(props) {
  //==========================Variables==========================//
  const { className, noDivider, noPadding, children, ...rest } = props;
  const classes = useStyles();
  const rootClassName = classNames(
    {
      [classes.root]: true,
      [classes.noDivider]: noDivider,
      [classes.noPadding]: noPadding,
    },
    className
  );

  return (
    <div {...rest} className={rootClassName}>
      {children}
    </div>
  );
}
